import {
    ACTION_HEADER, ACTIONS_FOR,
    DEFAULT_PAGINATION_SIZE,
    NO_RESULTS_FOUND,
    REPORT_COURSE_ACTIVITY_TABLE_HEADERS,
    REPORT_COURSE_TABLE_SEARCH_BOX_PLACEHOLDER,
    REPORT_COURSE_TABLE_VIEW_POLL_REPORT_LABEL,
    SEARCH_POLL,
    SEARCH_TEXT,
} from "../../utils/constants";

import classes from "./Report.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import React, {useEffect, useState} from "react";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";

import YuJaButton from "../../components/standardization/YuJaButton";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import styles from "../ManagePollsPage/ManagePolls.module.css";
import {Table} from "react-bootstrap";
import NormalPagination from "../../components/pagination/NormalPagination";
import {useHistory} from "react-router-dom";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";

const columns = [
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.POLL_INDEX.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.POLL_INDEX.name, width: 120},
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.TITLE.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.TITLE.name, width: 500 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.PARTICIPANT_COUNT.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.PARTICIPANT_COUNT.name, width: 180 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.DATE.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.DATE.name, width: 120 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ACTION.description, accessor: "", width: 90 }
];


const columns2 = [
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ATTENDANCE_INDEX.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ATTENDANCE_INDEX.name, width: 120},
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.TITLE.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.TITLE.name, width: 500 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.PARTICIPANT_COUNT.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.PARTICIPANT_COUNT.name, width: 180 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.DATE.description, accessor: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.DATE.name, width: 120 },
    { Header: REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ACTION.description, accessor: "", width: 90 }
];

const indexHeaders =  [
    REPORT_COURSE_ACTIVITY_TABLE_HEADERS.POLL_INDEX.description,
    REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ATTENDANCE_INDEX.description
];

export default function TabActivities({data, setData, isPoll=true}) {
    let history = useHistory();

    const [keyword, setKeyword] = useState();
    const [pageIdx, setPageIdx] = useState(0);
    const [filter, setFilter] = useState({});

    const [sortedBy, setSortedBy] = useState("");




    const clickSearch = () => {
        setFilter({keyword});
        setPageIdx(0);
    }

    useEffect(() => {
        setGlobalFilter(filter);
    }, [data, filter]);

    const filterCustomize = (rows, _, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.pollTitle && values.pollTitle.toLowerCase().indexOf(filteredKeyword.toLowerCase()) > -1) {
                return true;
            }

            return false;
        });
    };



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize},
        setGlobalFilter,
    } = useTable({
        columns: isPoll ? columns : columns2,
        data,
        initialState: { pageIndex: 0, pageSize: DEFAULT_PAGINATION_SIZE },
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);


    const onClickViewActivityReport = (pollKey, pollCode) => {
        if (!!pollKey) {
            document.getElementsByTagName("main")[0].scrollTo(0, 0);
            history.push({
                pathname: `/report/activity/${pollKey}/${pollCode}`,
                // state: { reportStartDate, reportEndDate}
            });
        }
    }

    return (
        <>
            <div className={classes.tableSearchBox}>
                <YuJaTextBox
                    label={SEARCH_POLL}
                    containerStyle={{fontSize: 15, marginLeft: 10, width: "70%"}}
                    placeholder={REPORT_COURSE_TABLE_SEARCH_BOX_PLACEHOLDER}
                    onChange={e => setKeyword(e.target.value)}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                />
                <YuJaButton onClick={clickSearch}>
                    <div style={{fontSize: 14, lineHeight: 1.6,}}>{SEARCH_TEXT}</div>
                </YuJaButton>
            </div>
            <div className={classes.tableWrapper}>
                <Table hover {...getTableProps()} >
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, idx) => {
                                    if (
                                        [
                                            REPORT_COURSE_ACTIVITY_TABLE_HEADERS.POLL_INDEX.name,
                                            REPORT_COURSE_ACTIVITY_TABLE_HEADERS.ATTENDANCE_INDEX.name,
                                            REPORT_COURSE_ACTIVITY_TABLE_HEADERS.TITLE.name,
                                            REPORT_COURSE_ACTIVITY_TABLE_HEADERS.PARTICIPANT_COUNT.name,
                                            REPORT_COURSE_ACTIVITY_TABLE_HEADERS.DATE.name
                                        ].includes(column.id)
                                    ) {
                                        return (
                                            <TableSortHeaderNew
                                                key={idx}
                                                data={data}
                                                setData={setData}
                                                sortedBy={sortedBy}
                                                setSortedBy={setSortedBy}
                                                propertyName={column.id}
                                                getProperty={(item) => item[column.id].toString()}
                                                label={column.Header}
                                                {...{
                                                    // ...column.getHeaderProps(),
                                                    key: column.id,
                                                    style: {
                                                        width: column.width,
                                                        textAlign: 'left',
                                                        backgroundClip: "padding-box",

                                                    }
                                                }}
                                            >
                                                <span
                                                    className={indexHeaders.includes(column.render('Header'))
                                                        ? classes.firstCell : classes.tableCell}
                                                >
                                                    {column.Header}
                                                </span>
                                            </TableSortHeaderNew>
                                        );
                                    } else {
                                        return (
                                            <th
                                                key={idx}
                                                {...column.getHeaderProps({
                                                    style: {
                                                        width: column.width,
                                                        textAlign: column.render('Header') === ACTION_HEADER ? 'center' : 'left'
                                                    }
                                                })}
                                            >
                                                <span className={ classes.tableCell}>
                                                    {column.Header}
                                                </span>
                                            </th>
                                        );
                                    }
                                })}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page && page.length !== 0 &&
                        page.map((row, index) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map((cell, index) => {
                                        if (cell.column.Header === ACTION_HEADER) {
                                            return (
                                                <td {...cell.getCellProps()} style={{textAlign: "center"}}>
                                                    <YuJaKebabMenuNew triggerAriaLabel={`${ACTIONS_FOR} ${row.original.pollTitle}`}>
                                                        <YuJaKebabMenuNew.Menu>
                                                            <YuJaKebabMenuNew.Item
                                                                onClick={() => onClickViewActivityReport(cell.row.original.pollKey, cell.row.original.pollCode)}
                                                            >
                                                                {REPORT_COURSE_TABLE_VIEW_POLL_REPORT_LABEL}
                                                            </YuJaKebabMenuNew.Item>
                                                        </YuJaKebabMenuNew.Menu>
                                                    </YuJaKebabMenuNew>
                                                </td>
                                            );
                                        } else {
                                            return (
                                                <td>
                                                    <div
                                                        className={indexHeaders.includes(cell.column.render('Header')) ? classes.firstCell : classes.tableCell}>
                                                        {cell.value}
                                                    </div>
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            );
                        })
                    }


                    {(!page || page.length === 0) &&
                        <tr>
                            <td colSpan="5" className={styles.noData} style={{boxShadow: "none"}}>
                                <div
                                    style={{
                                        justifyContent: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: 5,
                                        padding: 20
                                    }}
                                >
                                    <NoResultIllustration/>
                                    <div style={{
                                        fontSize: "18px",
                                        marginTop: "10px",
                                        fontWeight: 600
                                    }}> {NO_RESULTS_FOUND} </div>
                                </div>
                            </td>
                        </tr>

                    }
                    </tbody>
                </Table>
            </div>
            {page && pageCount > 1 &&
                <div style={{flex: 1, display: "flex", alignItems: "flex-end"}}>
                    <NormalPagination
                        pageCount={pageCount}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        gotoPage={gotoPage}
                        paddingTop="0px"
                    />
                </div>
            }
        </>
    );
}